import { jsx as _jsx } from "react/jsx-runtime";
import translations from "../../translations/resources/en-GB.json";
import FirstPage from "../../pages/FirstPage/FirstPage";
import { OVERVIEW_PAGE } from "../../store/common/constants";
export var TabConfigList = {
    overview: {
        title: translations.data["venonboard.tab.overview"],
    },
    indoorMap: {
        title: translations.data["venonboard.venueList.headline"],
        component: _jsx(FirstPage, {}),
    },
    internalTools: {
        title: translations.data["venonboard.tab.internalTools"],
        component: _jsx(FirstPage, {}),
    },
    documentation: {
        title: translations.data["venonboard.tab.documentation"],
        url: OVERVIEW_PAGE.GET_STARTED_LINK,
    },
};
